export default __webpack_public_path__ + "static/media/HZ_img.5ee3e151.png";